'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ToggleOn = function ToggleOn(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 8 6.2' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M0 3.5c0 .2.2.4.3.5l2.8 2c.4.3.9.2 1.2-.2l3.5-4.6c.4-.2.3-.7-.1-1-.4-.3-.9-.2-1.2.1l-3 3.9-2.1-1.5C1 2.4.5 2.5.2 2.9c-.2.1-.2.4-.2.6z', className: 'st0'
      })
    )
  );
};
/*eslint-enable */

exports.default = ToggleOn;
//# sourceMappingURL=ToggleOn.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ToggleOn.js